import { Injectable } from '@angular/core';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Observable } from 'rxjs';

import { AuthService } from '../auth.service';

/** Pass untouched request through to the next request handler. */
@Injectable()
export class TokenInterceptor implements HttpInterceptor {
  constructor(private authService: AuthService) {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    // Si la petición ya trae Authorization (p. ej. el handoff SSO, que lo setea
    // explícitamente con el token de la cookie recién entregada por la app),
    // se respeta. Pisarlo aquí con el token de sesión persistido puede mandar
    // un token vencido y provocar el 401 -> HOME silencioso.
    if (req.headers.has('Authorization')) {
      return next.handle(req);
    }
    const authToken = this.authService.token;
    if (authToken != null) {
      const authReq = req.clone({
        headers: req.headers.set('Authorization', 'Bearer ' + authToken),
      });
      return next.handle(authReq);
    }
    return next.handle(req);
  }
}
